module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[23]388.8480fc2.woff2";